var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CatalogSelect",
    _vm._g(
      {
        attrs: {
          id: _vm.id,
          "is-disabled": _vm.isDisabled,
          fetchData: _vm.fetchData,
          searchData: _vm.searchData
        },
        scopedSlots: _vm._u([
          {
            key: "create-catalog",
            fn: function(ref) {
              var refresh = ref.refresh
              return [_c("worker-complaint", { on: { refresh: refresh } })]
            }
          }
        ])
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cb837d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb837d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkerComplaints/WorkerComplaintSelect.vue
// module id = null
// module chunks = 